<template>
  <a
    class="dui-gallery-thumbnail"
    :class="{ 'editable': isEditable }"
  >
    <img
      class="thumbnail"
      :src="image"
      @click="clickPerformed"
    >
    <span
      v-if="isEditable"
      class="button-remove button-black button-icon button-close-white"
      @click.stop.prevent="removePerformed"
    />
  </a>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickPerformed() {
      this.$emit('click');
    },
    removePerformed() {
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.dui-gallery-thumbnail {
  border-radius: $border-radius-lg;
  line-height: 0;
  position: relative;

  &.editable:hover,
  &.highlight {
    .thumbnail {
      border-color: getColor($yellow) !important;
    }
  }

  &.editable:hover {
    .button-remove {
      opacity: 1;
      pointer-events: all;
    }
  }

  .thumbnail {
    background-color: getColor($grey, medium);
    border-radius: $border-radius-lg;
    border: $border-width-lg solid getColor($white);
    display: inline-block;
    position: relative;
    max-height: 100%;
    max-width: 100%;

    @include transition((
      border-color
    ));
  }

  .button-remove {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: -$_1-5em;
    top: -$_1-5em;
    z-index: 1;

    @include transition((
      opacity
    ));
  }
}
</style>
